/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionMatchStatus } from './CompetitionMatchStatus';
import {
    CompetitionMatchStatusFromJSON,
    CompetitionMatchStatusFromJSONTyped,
    CompetitionMatchStatusToJSON,
    CompetitionMatchStatusToJSONTyped,
} from './CompetitionMatchStatus';

/**
 * 
 * @export
 * @interface BracketMatch
 */
export interface BracketMatch {
    /**
     * UUID for this match
     * @type {string}
     * @memberof BracketMatch
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof BracketMatch
     */
    team1Id?: string;
    /**
     * 
     * @type {string}
     * @memberof BracketMatch
     */
    team2Id?: string;
    /**
     * 
     * @type {number}
     * @memberof BracketMatch
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof BracketMatch
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof BracketMatch
     */
    winnerId?: string;
    /**
     * 
     * @type {CompetitionMatchStatus}
     * @memberof BracketMatch
     */
    status?: CompetitionMatchStatus;
    /**
     * 
     * @type {number}
     * @memberof BracketMatch
     */
    scheduledTime?: number;
    /**
     * 
     * @type {number}
     * @memberof BracketMatch
     */
    completedAt?: number;
    /**
     * Match ID where winner advances to
     * @type {string}
     * @memberof BracketMatch
     */
    nextMatchId?: string;
    /**
     * True if this is a bye (auto-advance)
     * @type {boolean}
     * @memberof BracketMatch
     */
    isBye?: boolean;
    /**
     * Reference to active MatchSession for real-time tracking
     * @type {string}
     * @memberof BracketMatch
     */
    matchSessionId?: string;
    /**
     * Reference to shared Match collection for detailed match data
     * @type {string}
     * @memberof BracketMatch
     */
    sharedMatchId?: string;
}



/**
 * Check if a given object implements the BracketMatch interface.
 */
export function instanceOfBracketMatch(value: object): value is BracketMatch {
    return true;
}

export function BracketMatchFromJSON(json: any): BracketMatch {
    return BracketMatchFromJSONTyped(json, false);
}

export function BracketMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): BracketMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'team1Id': json['team1Id'] == null ? undefined : json['team1Id'],
        'team2Id': json['team2Id'] == null ? undefined : json['team2Id'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
        'status': json['status'] == null ? undefined : CompetitionMatchStatusFromJSON(json['status']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'completedAt': json['completedAt'] == null ? undefined : json['completedAt'],
        'nextMatchId': json['nextMatchId'] == null ? undefined : json['nextMatchId'],
        'isBye': json['isBye'] == null ? undefined : json['isBye'],
        'matchSessionId': json['matchSessionId'] == null ? undefined : json['matchSessionId'],
        'sharedMatchId': json['sharedMatchId'] == null ? undefined : json['sharedMatchId'],
    };
}

export function BracketMatchToJSON(json: any): BracketMatch {
    return BracketMatchToJSONTyped(json, false);
}

export function BracketMatchToJSONTyped(value?: BracketMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'team1Id': value['team1Id'],
        'team2Id': value['team2Id'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerId': value['winnerId'],
        'status': CompetitionMatchStatusToJSON(value['status']),
        'scheduledTime': value['scheduledTime'],
        'completedAt': value['completedAt'],
        'nextMatchId': value['nextMatchId'],
        'isBye': value['isBye'],
        'matchSessionId': value['matchSessionId'],
        'sharedMatchId': value['sharedMatchId'],
    };
}

